import { render, staticRenderFns } from "./giftStore.vue?vue&type=template&id=54c64a88"
import script from "./giftStore.vue?vue&type=script&lang=js"
export * from "./giftStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports